
const url = require('url');

import ko from 'rgs-knockout';
const _ = require('lodash');
const Q = require('q');

const Emitter = require('component-emitter');

const Bloodhound = require('rgs-bloodhound');
const gtm = require('google-tag-manager');

const server = require('server');

const modals = require('modals');

import ObservableMap from 'observable-map';

const template = require('./templates/modal.html');


/*
 * Modal dialog for settlement selection.
 * See `Controller` below for api.
 * Goes with './templates/modal.html' template
 */

function Model (options) {
	const kv = ko.validation;

	let model = {
		options,

		Regions: ko.observable([]),
		RegionsLoading: ko.observable(false),

		RegionID: ko.observable(),
		Settlement: (function () {
			const self = {};
			self.Name = ko.observable();
			self.Kladr = ko.pureComputed(function () {
				return options.settlementsMap.get(
					self.Name()
				);
			});
			return self;
		}()),

		Header: options.header,
	};

	model.RegionID.extend({
		validation: [{
			validator: function (v) {
				return Boolean(v);
			},
			message: 'выберите регион',
		}],
	});

	model.Settlement.Name.extend({
		required: {
			params: true,
			message: [
				'выберите населенный пункт',
				'выберите населенный пункт из меню',
			],
			onlyIf: function () {
				return Boolean(model.RegionID());
			},
		},
	});

	_.extend(model, {
		ValidationGroup: kv.computedGroup(function () {
			return [
				model.RegionID,
				model.Settlement.Name,
			];
		}),
	});

	model = Emitter(model);

	return model;
}

function Controller (options) {
	options = _.defaultsDeep({}, options, {
		/* optional */

		// settlements dataset variant
		settlementsDataset: 'kladr', // or 'rsa' or `instanceof Bloodhound`
		valueType: 'kladr', // or 'name'

		// A function used to get the regions list,
		// should return a promise of array
		regionsSource: () => {
			return server.any.api.dictionary.regionsTimeShift().then(_.property('responseJSON'));
		},

		// Mapping between settlement name and settlement id
		settlementsMap: null,

		gtmProcessing: {
			showModalEventValue: '',
			closeModalEventValue: '',
			chooseEventValue: '',
			successEventValue: '',
			errorEventValue: '',
		},

		// Typeahead options for settlement input
		settlementTypeahead: {
			options: {
				hint: true,
				highlight: true,
				minLength: 1,
			},
			dataset: {
				limit: 50,
				displayKey: 'label',
			},
		},

		// Modal header
		header: 'Выберите населенный пункт',
	});

	if (!options.settlementsMap) {
		options.settlementsMap = new ObservableMap();
	}

	function pushConversionChuteEvent (event, data = {}) {
		gtm.pusher()
			.event(event)
			.extend(data)
			.push();
	}

	function makeAddToDictionaryCallback (dict) {
		return function (response) {
			_.each(response, function (record) {
				dict.biset(parseInt(record.value), record.label || record.name, true);
			});
			dict.notify();
			return response;
		};
	}

	function makeDataset (dataset) {
		if (_.isFunction(dataset)) {
			return ko.pureComputed(() => dataset(model.RegionID()));
		}

		if (_.isObject(dataset)) {
			return dataset;
		}
		return {
			display: 'label',
			source: new Bloodhound({
				remote: {
					url: dataset === 'rsa'
						? '/api/dictionary/citiesKladrRsa'
						: '/api/dictionary/citiesKladr',
					prepare: function (query, settings) {
						const region = model.RegionID();
						settings.url = url.format(_.extend(url.parse(settings.url), {
							query: {
								cityTerm: query,
								region,
							},
						}));
						return settings;
					},
					transform: makeAddToDictionaryCallback(options.settlementsMap),
				},
				identify: 'value',
				datumTokenizer: Bloodhound.tokenizers.obj.nonwordRus('label'),
			}),
			limit: 30,
		};
	}

	options.settlementsDataset = makeDataset(options.settlementsDataset);

	const model = new Model(options);

	const modal = modals.create({
		templateMode: 'content',
		template: {
			html: template(),
			data: model,
		},
	});

	modal.on('hidden', () => {
		if (options.gtmProcessing.closeModalEventValue !== '') {
			pushConversionChuteEvent(options.gtmProcessing.closeModalEventValue);
		}
		api.emit('hidden');
	});

	const api = Emitter({
		/*
		 * Events (use like `ctrl.on('select', function () { ... })`):
		 *
		 * * select -- Fired when user selected a valid settlement. Handler
		 * will be called with the settlement id
		 */

		promise: function (options) {
			/*
			 * Show modal and return a promise that is later resolved with
			 * the selected value, or with null if closed
			 */

			options = _.extend({
				// Clear inputs before showing
				clear: false,
			}, options);

			const dfr = Q.defer();

			const onSelect = function (value) {
				off();
				dfr.resolve(value);
			};
			const onHidden = function () {
				off();
				dfr.resolve(null);
			};

			const on = function () {
				api.on('select', onSelect);
				api.on('hidden', onHidden);
			};
			var off = function () {
				api.off('select', onSelect);
				api.off('hidden', onHidden);
			};

			if (options.clear) {
				api.clear();
			}
			on();

			return api.show().then(() => dfr.promise);
		},
		show: function () {
			/*
			 * Show modal and load regions if they are not loaded yet
			 */

			modals.show(modal);

			if (options.gtmProcessing.showModalEventValue !== '') {
				pushConversionChuteEvent(options.gtmProcessing.showModalEventValue);
			}


			if (model.RegionsLoading() || model.Regions().length) {
				return Q();
			}

			model.RegionsLoading(true);

			return Q(options.regionsSource()).then(function (data) {
				model.Regions(data);
			}).fin(function () {
				model.RegionsLoading(false);
			}).then(() => modal);
		},
		hide: function () {
			/*
			 * Hide modal
			 */
			modals.hide(modal);
		},
		clear: function () {
			/*
			 * Reset all inputs to their empty values
			 */

			model.RegionID(null);
			model.Settlement.Name(null);
		},
	});

	model.on('RegionSelectChange', function () {
		model.Settlement.Name('');
	});

	model.on('SettlementSelectedClick', function () {
		const invalid = !model.ValidationGroup().isValid();
		if (invalid) {

			if (options.gtmProcessing.errorEventValue !== '') {
				pushConversionChuteEvent(options.gtmProcessing.errorEventValue, {
					formErrors: model.ValidationGroup()().join(),
				});
			}
			model.ValidationGroup().showAllMessages(invalid);
			return;
		}

		api.emit('select', options.valueType === 'name'
			? model.Settlement.Name()
			: model.Settlement.Kladr()
		);
		if (options.gtmProcessing.successEventValue !== '') {
			pushConversionChuteEvent(options.gtmProcessing.successEventValue);
		}
		api.hide();
	});

	return api;
}

module.exports = Controller;

